import { useEffect, useState } from 'react';
import { TablePagination } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import MainTable from './MainTable';

function DataTable({ columnTitles, columnWidths, noInfoImage, ...props }: any) {
    const { t } = useTranslation('common');
    const { filters, setFilters, items, isLoading, noPaginated, noInfoTitle, noInfoSubtitle } =
        props;
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleChangeRowsPerPage = (newRowsPerPage: number) => {
        setRowsPerPage(newRowsPerPage);
        setPage(0);
        setFilters((prevFilters: any) => ({ ...prevFilters, take: newRowsPerPage, skip: 0 }));
    };
    const [page, setPage] = useState(0);

    useEffect(() => {
        if (filters?.skip === 0) setPage(0);
    }, [filters]);

    const handleChangePage = (_: any, newPage: number) => {
        const skip = filters.skip;
        const take = filters.take;
        setFilters({
            ...filters,
            skip: newPage > page ? skip + take : skip - take
        });
        setPage(newPage);
    };

    if (isLoading) return <Loading />;
    return (
        <MainTable
            {...props}
            items={items?.data?.data|| []}
            columnTitles={columnTitles}
            columnWidths={columnWidths}
            noInfoTitle={noInfoTitle}
            noInfoSubtitle={noInfoSubtitle}
            noInfoImage={noInfoImage}
        >
            {!noPaginated && !(page === 0 && items?.data?.data?.length < 10) && (
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50, 100, filters.take].filter(
                        (value, index, self) => self.indexOf(value) === index
                    )}
                    labelDisplayedRows={({ from, to, count }) => {
                        return `${from}–${to} ${t('table.pagination.of')} ${count} items`;
                    }}
                    component="div"
                    rowsPerPage={filters.take || 0}
                    count={props?.count || items?.data?.count || 0}
                    page={items?.data?.count <= 10 ? 0 : page}
                    onPageChange={handleChangePage}
                    labelRowsPerPage={t('table.pagination.rowsPerPage')}
                    onRowsPerPageChange={(event) =>
                        handleChangeRowsPerPage(parseInt(event.target.value, 10))
                    }
                />
            )}
        </MainTable>
    );
}

export default DataTable;
